import axios from 'axios'

export function useHttp () {
  const fnAxios = (method, pUrl, pData, request, loading) => {
    // const cancelToken = axios.CancelToken
    // const source = cancelToken.source()
    const urlroute = pUrl
    loading.value.loading = true
    axios({
      url: urlroute,
      method: method,
      data: pData
      // cancelToken: source.token
    }).then(response => {
      request.value.data = response.data
      if (response.data.status === 0) {
        request.value.error = response.data.data
      }
    }).catch(error => {
      request.value.error = error
      if (error.response.status === 422) {
        request.value.data = error.response.data.message
        request.value.validate = error.response.data.errors
        request.value.tipo = 'ERROR VALIDACION'
      }
    }).finally(() => {
      request.value.status = 3
      loading.value.loading = false
    })
  }

  const fnAxiosToken = (method, pUrl, pToken, pData, request, loading) => {
    const urlroute = pUrl
    loading.value.loading = true
    // const cancelToken = axios.CancelToken
    // const source = cancelToken.source()

    axios({
      url: urlroute,
      method: method,
      data: pData,
      // cancelToken: source.token,
      headers: {
        Authorization: 'Bearer ' + pToken
      }
    }).then(response => {
      request.value.data = response.data
      if (typeof response.data.status !== 'undefined' && response.data.status === 0) {
        request.value.error = response.data.data
      }
    }).catch(error => {
      request.value.error = error
      if (error.response.status === 422) {
        request.value.data = error.response.data.message
        request.value.validate = error.response.data.errors
        request.value.tipo = 'ERROR VALIDACION'
      }
    }).finally(() => {
      request.value.status = 3
      loading.value.loading = false
    })
  }

  const fnAxiosTokenCustomer = (method, pUrl, pToken, pData, objecto, loading, request) => {
    const urlroute = pUrl
    loading.value.loading = true
    axios({
      url: urlroute,
      method: method,
      data: pData,
      // cancelToken: source.token,
      headers: {
        Authorization: 'Bearer ' + pToken
      }
    }).then(response => {
      objecto.value.data = response.data
    }).catch(error => {
      request.value.error = error
    }).finally(() => {
      request.value.status = 3
      loading.value.loading = false
    })
  }

  const fnAxiosTokenDownload = (method, pUrl, pToken, pData, loading, filename, request) => {
    const urlroute = pUrl
    loading.value.loading = true
    axios({
      url: urlroute,
      method: method,
      data: pData,
      headers: {
        Authorization: 'Bearer ' + pToken
      },
      responseType: 'arraybuffer'
    }).then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename) // 'gestiones.xlsx'
      document.body.appendChild(link)
      link.click() // force download file without open new tab
    }).catch(error => {
      request.value.error = error
    }).finally(() => {
      request.value.status = 3
      loading.value.loading = false
    })
  }

  const fnAxiosTokenDownloadContents = (method, pUrl, pToken, pData, objecto, loading, request) => {
    const urlroute = pUrl
    loading.value.loading = true
    axios({
      url: urlroute,
      method: method,
      data: pData,
      headers: {
        Authorization: 'Bearer ' + pToken
      }
    }).then(response => {
      // objecto.value.data = new Blob([response.data])
      objecto.value.data = response.data
    }).catch(error => {
      request.value.error = error
    }).finally(() => {
      request.value.status = 3
      loading.value.loading = false
    })
  }

  const fnAxiosTokenDownloadContentsFile = (method, pUrl, pToken, pData, objecto, loading, request, pNameFile) => {
    const urlroute = pUrl
    loading.value.loading = true
    axios({
      url: urlroute,
      method: method,
      data: pData,
      headers: {
        Authorization: 'Bearer ' + pToken
      },
      responseType: 'blob'
    }).then(response => {
      const contentType = response.headers['content-type'] || 'application/octet-stream'

      const blob = new Blob([response.data], { type: contentType })
      const file = new File([blob], pNameFile, { type: contentType })
      objecto.value.data = file

      objecto.value.data = new File([blob], pNameFile, { type: contentType })
    }).catch(error => {
      request.value.error = error
    }).finally(() => {
      loading.value.loading = false
    })
  }

  const fnAxiosFile = (method, pUrl, pToken, pData, request, progress) => {
    progress.value.progress = 0
    progress.value.loading = true
    const urlroute = pUrl
    axios({
      url: urlroute,
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: 'Bearer ' + pToken
      },
      method: method,
      data: pData,
      onUploadProgress: function (e) {
        let percentComplete = e.loaded / e.total
        percentComplete = parseInt(percentComplete * 100)
        progress.value.progress = percentComplete
      }.bind()
    }).then(response => {
      request.value.data = response.data
      if (response.data.status === 0) {
        request.value.error = response.data.data
      }
    }).catch(error => {
      request.value.error = error
      if (error.response.status === 422) {
        request.value.data = error.response.data.message
        request.value.validate = error.response.data.errors
        request.value.tipo = 'ERROR VALIDACION'
      }
    }).finally(() => {
      request.value.status = 3
      progress.value.loading = false
    })
  }

  const fnAxiosFileCustomer = (method, pUrl, pToken, pData, objecto, progress, request) => {
    progress.value.progress = 0
    progress.value.loading = true
    const urlroute = pUrl
    axios({
      url: urlroute,
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: 'Bearer ' + pToken
      },
      method: method,
      data: pData,
      onUploadProgress: function (e) {
        let percentComplete = e.loaded / e.total
        percentComplete = parseInt(percentComplete * 100)
        progress.value.progress = percentComplete
      }.bind()
    }).then(response => {
      objecto.value.files = response.data.data
      request.value.files = response.data.data
      request.value.data = response.data
      if (response.data.status === 0) {
        request.value.error = response.data.data
      }
    }).catch(error => {
      request.value.error = error
      if (error.response.status === 422) {
        request.value.data = error.response.data.message
        request.value.validate = error.response.data.errors
        request.value.tipo = 'ERROR VALIDACION'
      }
    }).finally(() => {
      request.value.status = 3
      progress.value.loading = false
    })
  }

  const fnAxiosAuth = (method, pUrl, pData, pHead, request, loading) => {
    const urlroute = pUrl
    loading.value.loading = true
    axios({
      url: urlroute,
      method: method,
      auth: {
        username: pHead.getHeadUsuario,
        password: pHead.getHeadPassword
      },
      data: pData
    }).then(response => {
      request.value.data = response.data
      if (typeof response.data.status !== 'undefined' && response.data.status === 0) {
        request.value.error = response.data.data
      }
    }).catch(error => {
      request.value.error = error
      if (error.response.status === 422) {
        request.value.data = error.response.data.message
        request.value.validate = error.response.data.errors
        request.value.tipo = 'ERROR VALIDACION'
      }
    }).finally(() => {
      request.value.status = 3
      loading.value.loading = false
    })
  }

  const fnAxiosAuthCustomer = (method, pUrl, pHead, pData, objecto, loading) => {
    const urlroute = pUrl
    loading.value.loading = true
    axios({
      url: urlroute,
      method: method,
      auth: {
        username: pHead.getHeadUsuario,
        password: pHead.getHeadPassword
      },
      data: pData
    }).then(response => {
      objecto.value.data = response.data
    }).catch(error => {
      objecto.value.error = error
    }).finally(() => {
      loading.value.loading = false
    })
  }

  const fnAxiosAuthFile = (method, pUrl, pHead, pData, request, progress) => {
    const urlroute = pUrl
    progress.value.loading = true
    axios({
      url: urlroute,
      method: method,
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      auth: {
        username: pHead.getHeadUsuario,
        password: pHead.getHeadPassword
      },
      data: pData
    }).then(response => {
      request.value.data = response.data
      if (typeof response.data.status !== 'undefined' && response.data.status === 0) {
        request.value.error = response.data.data
      }
    }).catch(error => {
      request.value.error = error
      if (error.response.status === 422) {
        request.value.data = error.response.data.message
        request.value.validate = error.response.data.errors
        request.value.tipo = 'ERROR VALIDACION'
      }
    }).finally(() => {
      request.value.status = 3
      progress.value.loading = false
    })
  }

  return { fnAxios, fnAxiosFile, fnAxiosAuth, fnAxiosAuthFile, fnAxiosAuthCustomer, fnAxiosToken, fnAxiosTokenDownloadContentsFile, fnAxiosTokenCustomer, fnAxiosTokenDownload, fnAxiosTokenDownloadContents, fnAxiosFileCustomer }
}
